export const kedDescription = <>
    <p className='text-secondary-light fw-medium'>
        <div className='fs-10'>Kurs składa się z 9 tygodni.</div>
        <br/>
        Na samym początku zaczniemy od zbudowania świadomości, na której będą bazowały wszystkie kolejne tygodnie.
        Następnie zajmiemy się podstawami efektywnego działania, aby być w stanie działać systematycznie i
        konsekwentnie realizować swoje cele. <b>Dwa pierwsze tygodnie są najważniejsze.</b><br/> Bez
        wykonania ćwiczeń i wdrożenia w życie
        zmian,
        przejście do kolejnych tygodni tylko Cię przytłoczy i niczego się nie nauczysz.
        <br/><br/>
        W trzecim tygodniu zajmiemy się podstawami efektywnej nauki i zrozumiemy, co tak naprawdę oznacza efektywna
        nauka i w jaki sposób można zmienić swoje aktualne nawyki - by spędzać mniej czasu nad książkami, a
        zapamiętywać i rozumieć więcej.
        <br/><br/>
        W czwartym tygodniu zoptymalizujemy nasze środowisko pracy/nauki, aby być maksymalnie produktywnym i nigdy
        więcej się nie rozpraszać.<br/><br/>
        W piątym tygodniu wejdziemy na średniozaawansowany poziom efektywnej nauki. Nauczymy się, w jaki sposób
        uczyć się w szkole, jak skutecznie pisać sprawdziany na topowe oceny, jak robić efektywne notatki oraz jak
        stworzyć swój własny system nauki. <br/><br/>
        W szóstym tygodniu skupimy się na optymalizacji naszego życia i szczegółowo omówimy tematy związane ze snem,
        sportem, jedzeniem i odpoczynkiem.<br/><br/>
        W siódmym tygodniu skupimy się na bardziej zaawansowanych aspektach efektywnej nauki, takich jak nauka
        poprzez dociekanie, tworzenie przemyślanych map myśli, kolejność nauki, sposoby nauki do przedmiotów
        ścisłych oraz omówimy wykorzystanie AI jako naszego pomocnika. <br/><br/>
        W ósmym tygodniu zajmiemy się wchodzeniem w stan flow, by nauka stała się bardzo przyjemna i aby w jeden
        dzień zrobić więcej, niż większość osób przez tydzień lub nawet miesiąc! <br/><br/>
        Zakończymy rozdziałem poświęconym na wejście poziom wyżej, dzięki któremu
        już nigdy nie wrócisz do swoich starych nawyków i nie zboczysz ze zwycięskiej ścieżki!<br/><br/>
        Pełny program Kursu wraz z opisem każdego
        odcinka, <a className='text-success text-decoration-underline' target="_blank"
                    href="https://docs.google.com/document/d/17eQ5cB8ZD7NsbcsHteTOztJVvydv4rPBPXL2dW2XeRI/edit?usp=sharing">znajdziesz
        pod tym linkiem</a>.<br/><br/>
        Jeżeli masz jakieś sugestie odnośnie filmów, śmiało dodaj swój komentarz w powyższym arkuszu.
    </p>
    <p className='text-secondary-light fw-medium'>Zalecamy oglądać filmy po kolei, aby niczego nie ominąć. Często
        kolejne lekcje bazują na poprzednich.</p>
    <p className='text-secondary-light fw-medium'>Kolejne tygodnie będą odblokowywane automatycznie - więcej
        informacji w Tygodniu 0.</p>
</>

export const kedV2Description = <>
    <p className='text-secondary-light fw-medium'>
        <div className='fs-10'>Kurs składa się z 6 tygodni.</div>
        <br/>
        Kurs Efektywnego Działania 2.0 to zupełnie nowa, ulepszona wersja oryginalnego kursu, stworzona specjalnie z
        myślą
        o nastolatkach, którzy chcą działać efektywniej i osiągać więcej.
        <br/><br/>
        <b>Tydzień 0: Organizacja</b> - Przywitanie i organizacja. Poznasz platformę, dowiesz się jak wynieść 100% z
        Kursu oraz otrzymasz dostęp do dodatkowych narzędzi.
        <br/><br/>
        <b>Tydzień 1: Świadomość & Środowisko</b> - Zbudujemy fundament efektywnego działania. Stworzysz swoją idealną
        wersję siebie (BEST Self), zoptymalizujesz swoje środowisko (telefon, komputer, biurko), poznasz Plan Dominacji
        i zrozumiesz różnicę między Fixed a Growth Mindset. <b>To kluczowy tydzień!</b>
        <br/><br/>
        <b>Tydzień 2: Podstawy Efektywnego Działania</b> - Nauczysz się różnicy między motywacją a nawykami, poznasz
        techniki antyprokrastynacyjne, dowiesz się jak zwiększyć koncentrację, poznasz Matrycę Eisenhowera, stworzysz
        mapę mocy i dowiesz się więcej o chronotypach snu.
        <br/><br/>
        <b>Tydzień 3: Wstęp do Efektywnej Nauki</b> - Poznasz metodę POP (Powtarzanie, Odzyskiwanie, Przeplatanie),
        nauczysz się jak skutecznie powtarzać materiał, zrozumiesz rolę snu w nauce, dowiesz się jak wykorzystać AI
        do nauki i jak planować naukę według metody SMART.
        <br/><br/>
        <b>Tydzień 4: Totalny ogar</b> - Praktyczne narzędzia do nauki: planowanie z AI, nauka na lekcji, techniki
        egzaminacyjne, efektywne notatki, fiszki, przerwy, rutyna przed nauką, kolejność nauki, radzenie sobie ze
        stresem i realizacja celów krok po kroku.
        <br/><br/>
        <b>Tydzień 5: Efektywna nauka 2.0</b> - Zaawansowane techniki: kiedy najlepiej zapamiętujemy, nauka poprzez
        dociekanie, mapy myśli, nauka do przedmiotów ścisłych, AI w nauce, powrót po przerwie, stan flow i nadrabianie
        materiału w krótkim czasie.
        <br/><br/>
        <b>Tydzień 6: Poziom wyżej</b> - Aspekty psychologiczne: prowadzenie dziennika, autentyczność, wpływ otoczenia,
        obraz siebie i samoocena, rola przekonań, wizualizacja celów, brain dump. Zakończymy podsumowaniem i planem
        na przyszłość.
    </p>
    <p className='text-secondary-light fw-medium'><b>Każdy odcinek zawiera możliwość robienia notatek.</b> Tam, gdzie są
        dodatkowe zadania, możesz również załączyć swoje rozwiązania.
        A po każdym tygodniu (1-6) czeka na Ciebie quiz sprawdzający Twoją wiedzę.</p>
    <p className='text-secondary-light fw-medium'>Zalecamy oglądać filmy po kolei, aby niczego nie ominąć. Kolejne
        lekcje bazują na poprzednich.</p>
    <p className='text-secondary-light fw-medium'>Kolejne tygodnie będą odblokowywane automatycznie - więcej
        informacji w Tygodniu 0.</p>
    <p className='text-secondary-light fw-medium'>Pełny program Kursu wraz z opisem każdego
        odcinka, <a className='text-success text-decoration-underline' target="_blank"
                    href="https://docs.google.com/document/d/1QIT1fk9TwbgWiuhN0bjQ4xVHxPvbwVclv-obclJStDU/edit?usp=sharing">znajdziesz
            pod tym linkiem</a>. </p>
</>

export const pedDescription = <>
    <p className='text-secondary-light fw-medium'>
        Zaczniemy od stworzenia "Najlepszej wersji siebie", dzięki której zdasz sobie sprawę, dokąd dążysz i jakie są
        Twoje cele. Staniesz się znacznie bardziej świadomą osobą i zobaczysz sens w tym, co robisz.
        <br/><br/>
        Następnie, wykorzystamy narzędzie "Roczny Plan Dominacji" do skutecznego zarządzania czasem i planowania.
        Nauczymy się, jak właściwie planować naukę i na co zwracać uwagę.
        <br/><br/>
        W kolejnym filmie zagłębimy się w temat Systematycznego Działania. Wiele osób wie, że powinni coś robić, ale
        jakoś nie mogą zmobilizować się do działania...<br/>
        Weźmiemy pod lupę temat prokrastynacji (odkładania rzeczy na później) i nauczymy się, jak pokonać ją raz na
        zawsze.
        <br/><br/>
        Zoptymalizujemy nasze miejsce pracy. Upewnimy się, że będziemy pracować w miejscu wolnym od
        rozpraszaczy, które sprzyja rozwojowi i skupieniu.
        <br/><br/>
        Później, spojrzymy na temat Efektywnej Nauki i nauczymy się solidnych podstaw. Dowiemy się, na czym polega POP
        (Powtórki, Odzyskiwanie, Przeplatanie) - oraz jak go wprowadzić w życie.
        <br/><br/>
        Na końcu, ułożymy jasny i konkretny plan działania, w którym wykorzystamy w praktyce wszystko, czego się
        nauczyliśmy.
    </p>
</>

export const spcDescription = <>
    <h4 className='text-white fw-bold fs-8 mb-3'>
        <i className='bi bi-file-earmark-pdf me-2 text-warning'></i>Materiały do pobrania
    </h4>
    <div className='row g-3 mb-6'>
        <div className='col-12 col-md-6'>
            <a href='https://produkacja.s3.eu-central-1.amazonaws.com/materialy/system-planowania-czasu/Infografika+Planowanie.pdf'
               target='_blank' rel='noopener noreferrer'
               className='d-flex align-items-center gap-3 p-3 rounded-3 text-decoration-none'
               style={{
                   background: 'rgba(255, 255, 255, 0.04)',
                   border: '1px solid rgba(255, 255, 255, 0.08)',
                   transition: 'all 0.2s ease',
               }}
               onMouseEnter={(e) => {
                   e.currentTarget.style.background = 'rgba(245, 158, 12, 0.08)';
                   e.currentTarget.style.borderColor = 'rgba(245, 158, 12, 0.25)';
               }}
               onMouseLeave={(e) => {
                   e.currentTarget.style.background = 'rgba(255, 255, 255, 0.04)';
                   e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
               }}
            >
                <div className='d-flex align-items-center justify-content-center rounded-2 flex-shrink-0'
                     style={{width: 40, height: 40, background: 'rgba(245, 158, 12, 0.1)'}}>
                    <i className='bi bi-file-earmark-pdf text-warning fs-9'></i>
                </div>
                <div>
                    <div className='text-white fw-semibold' style={{fontSize: '0.9rem'}}>Infografika — Planowanie</div>
                    <div className='text-white-50' style={{fontSize: '0.78rem'}}>PDF <i className='bi bi-download ms-1' style={{fontSize: '0.7rem'}}></i></div>
                </div>
            </a>
        </div>
        <div className='col-12 col-md-6'>
            <a href='https://produkacja.s3.eu-central-1.amazonaws.com/materialy/system-planowania-czasu/Planowanie+-+Cheat-Sheet.pdf'
               target='_blank' rel='noopener noreferrer'
               className='d-flex align-items-center gap-3 p-3 rounded-3 text-decoration-none'
               style={{
                   background: 'rgba(255, 255, 255, 0.04)',
                   border: '1px solid rgba(255, 255, 255, 0.08)',
                   transition: 'all 0.2s ease',
               }}
               onMouseEnter={(e) => {
                   e.currentTarget.style.background = 'rgba(245, 158, 12, 0.08)';
                   e.currentTarget.style.borderColor = 'rgba(245, 158, 12, 0.25)';
               }}
               onMouseLeave={(e) => {
                   e.currentTarget.style.background = 'rgba(255, 255, 255, 0.04)';
                   e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
               }}
            >
                <div className='d-flex align-items-center justify-content-center rounded-2 flex-shrink-0'
                     style={{width: 40, height: 40, background: 'rgba(245, 158, 12, 0.1)'}}>
                    <i className='bi bi-file-earmark-pdf text-warning fs-9'></i>
                </div>
                <div>
                    <div className='text-white fw-semibold' style={{fontSize: '0.9rem'}}>Cheat-Sheet — Planowanie</div>
                    <div className='text-white-50' style={{fontSize: '0.78rem'}}>PDF <i className='bi bi-download ms-1' style={{fontSize: '0.7rem'}}></i></div>
                </div>
            </a>
        </div>
    </div>
    <p className='text-secondary-light fw-medium'>
        System Planowania Czasu to zestaw wybranych materiałów z naszego Kursu Efektywnego Działania 2.0, skupionych
        wyłącznie na planowaniu czasu i efektywnym działaniu.
        <br/><br/>
        Poniżej znajdziesz 5 lekcji wideo, które przeprowadzą Cię krok po kroku przez cały system — od pokonania
        prokrastynacji, przez określanie priorytetów i świadomość czasu, po planowanie nauki metodą SMART.
        <br/><br/>
        Dodatkowo, powyżej znajdziesz dwie ściągawki PDF do wydrukowania — idealne do powieszenia nad biurkiem i
        codziennego użytku.
    </p>
    <p className='text-secondary-light fw-medium'>Zalecamy oglądać filmy po kolei, aby niczego nie ominąć.</p>
</>

export const znDescription = <>
    <p className='text-secondary-light fw-medium'>
        Doskonale zdajemy sobie sprawę z tego, że jako rodzic na pewno masz dużo na głowie i nie masz czasu na oglądanie
        bardzo długich Kursów, dlatego skompresowaliśmy całą najważniejszą wiedzę w raptem 1.5h filmów, żebyś mógł/mogła
        wprowadzić realne zmiany już w ciągu kilku najbliższych dni. <br/><br/>

        Przejdziemy przez <b>trzy główne moduły</b>, takie jak:
        <ol className='mt-1'>
            <li className='mb-1'>Zrozumieć nastolatka</li>
            <li className='mb-1'>Komunikacja z nastolatkiem</li>
            <li className='mb-1'>Wsparcie Nastolatka w edukacji</li>
        </ol>
        Po tym Kursie będziesz znacznie lepiej rozumiał/a to, co siedzi w głowie nastolatka, a Twoje relacje z dzieckiem
        znacząco się poprawią.
    </p>
</>